import { Component, OnChanges, Input } from '@angular/core';
import { PaymentProfileStatus } from '../../../../../models/_enum-collections';
import { PartnerPaymentDetails } from '../../../../../models/partner-payment-details.model';
import { VendorService } from '../../../../services/vendor.service';
import { CommonSharedModule } from '../../../../common/shared.module';
import { IPaymentProfile } from '../../../../../models/payment-profile-2.model';

@Component({
  selector: 'app-payment-profile-tab',
  templateUrl: './payment-profile-tab.component.html',
  styleUrls: ['./payment-profile-tab.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class PaymentProfileTabComponent implements OnChanges {
  @Input() partnerPaymentDetails!: PartnerPaymentDetails;

  loading = true;
  payeeContactName!: string;
  paymentProfileDetails: IPaymentProfile = {
    payeeContactEmail: '',
    payeeContactName: '',
    payeeName: '',
    paymentProfileStatusDescription: '',
    vendorId: 0,
    statusColor: '',
    programAgrementStatus: false
  };
  constructor(private paymentProfileService: VendorService) {}

  ngOnChanges() {
    if (
      this.partnerPaymentDetails &&
      this.partnerPaymentDetails.paymentProfileInfo
    ) {
      this.loading = false;
      this.computePayeeContactName();
      this.paymentProfileDetails.payeeName =
        this.partnerPaymentDetails.paymentProfileInfo.payeeName;
      this.paymentProfileDetails.payeeContactName = this.payeeContactName;
      this.paymentProfileDetails.payeeContactEmail =
        this.partnerPaymentDetails.paymentProfileInfo.payeeContactEmail;
      this.paymentProfileDetails.vendorId =
        this.partnerPaymentDetails.vendorId || -1;
      this.paymentProfileDetails.paymentProfileStatusDescription =
        this.partnerPaymentDetails.paymentProfileStatusDescription != null
          ? this.partnerPaymentDetails.paymentProfileStatusDescription
          : PaymentProfileStatus.Missing;
      this.paymentProfileDetails.statusColor =
        this.paymentProfileService.getStyleForPaymentProfileStatus(
          this.partnerPaymentDetails.paymentProfileStatusDescription || ''
        );
      this.paymentProfileDetails.programAgrementStatus =
        this.partnerPaymentDetails.programAgreementStatus || false;
    }
  }

  get PaymentProfileStatus(): typeof PaymentProfileStatus {
    return PaymentProfileStatus;
  }

  computePayeeContactName() {
    if (
      this.partnerPaymentDetails &&
      this.partnerPaymentDetails.paymentProfileInfo
    ) {
      const firstName =
        this.partnerPaymentDetails.paymentProfileInfo.payeeFirstName;
      const lastname =
        this.partnerPaymentDetails.paymentProfileInfo.payeeLastName;
      if (
        this.isValidName(firstName || '') &&
        this.isValidName(lastname || '')
      ) {
        this.payeeContactName = firstName + ' ' + lastname;
      } else if (this.isValidName(firstName || '')) {
        this.payeeContactName = firstName || '';
      } else if (this.isValidName(lastname || '')) {
        this.payeeContactName = lastname || '';
      } else {
        this.payeeContactName = 'NA';
      }
    } else {
      this.payeeContactName = 'NA';
    }
  }

  private isValidName(value: string): boolean {
    return value !== null && value !== 'NA';
  }

  getStyleForPaymentProfileStatus(status: string) {
    return this.paymentProfileService.getStyleForPaymentProfileStatus(status);
  }

  getPaymentProfileStatus(status: string) {
    return this.paymentProfileService.getPaymentProfileStatus(status);
  }
}
